import { GoSuiteApp } from "go-app/services/types";

export const getNewAppsVersion = (
	duplicateApplications: string[],
	applicationsFromConfig: GoSuiteApp[]
): GoSuiteApp[] => {
	const newApplicationsFromConfig = [...applicationsFromConfig];
	duplicateApplications.forEach((duplicateApplication) => {
		const oldDuplicateAppIndex = newApplicationsFromConfig.findIndex(
			(app) => app.id.toUpperCase() === duplicateApplication && app.old
		);
		newApplicationsFromConfig.splice(oldDuplicateAppIndex, 1);
	});
	return newApplicationsFromConfig;
};
